import CountdownBanner from "./CountdownBanner";

export default function BFCMSubscriberBanner({ promotion }) {
  if (!promotion) return null;

  return (
    <CountdownBanner
      title={`banners.bfcm-subscriber.title`}
      timerTitle={`banners.bfcm-subscriber.title-timer`}
      prefix={"bfcm-subscriber"}
      promotion={promotion}
    />
  );
}
